import { object, string, number, array ,date, InferType } from 'yup';

const QuoteEmailScheme = object({
    clientemail: string().email().required(),
    cc: string().email().required(),
    subject: string().required(),
    htmlContent: string().required()
})

export default QuoteEmailScheme